import { Modal } from 'antd';
import styles from "./modal.module.css";

interface ModalProps{
    heading? : React.ReactNode;
    maxWidth? : 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    isOpen : boolean;
    content? : React.ReactNode
    handleClose: () => void;
}
const CustomModal: React.FC<ModalProps> = ({heading, maxWidth, isOpen, content, handleClose}) => {
  return (
    <>
      <Modal
        title={<p className={styles.heading}>{heading && heading}</p>}
        centered
        open={isOpen}
        width={500}
        onCancel={handleClose}
        footer={null}
        className={styles.modal}
      >
      <div>{content}</div>
      </Modal>
    </>
  );
};

export default CustomModal;




